import { render, staticRenderFns } from "./crowd.vue?vue&type=template&id=39990c8e&"
import script from "./crowd.vue?vue&type=script&lang=js&"
export * from "./crowd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports